<template>
	<div class="sale-source">
		<headerTemplate title="货源管理"></headerTemplate>
		<div class="source-box" v-for="(item, i) in sourceList" :key="i">
			<a :href="item.source_url">
				<div class="source-box-item">
					<van-image class="img-show" :src="imgUrl + item.source_img" />
					<div class="detail-wapper">
						<h3 class="detail-wapper-h3">{{item.source_name}}</h3>
						<p>{{item.source_cotent}}</p>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
	import { getSource } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleSource',
		components: {
			headerTemplate
		},
		data() {
			return {
				sourceList: []
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			}
		},
		created() {
			// debugger
			getSource().then(res => {
				this.sourceList = res.result
			}).catch(error => {
				// alert
			})
		}
	}
</script>

<style lang="scss" scoped>
	.sale-source {
		font-size: 14px !important;

		.source-box {
			a {
				color: #333333;
			}

			.source-box-item {
				display: flex;
				box-shadow: 0 0 5px #eee;
				background-color: #FFFFFF;
				margin: 10px;
				padding: 10px;
				border-radius: 10px;

				.detail-wapper {
					margin-left: 10px;

					.detail-wapper-h3 {
						font-weight: 600;
						margin-bottom: 5px;
					}
				}

				&:hover {
					box-shadow: 0 0 5px #333333;
				}
			}
		}
	}

	.img-show {
		min-width: 30%;
		padding: 5px;
		width: auto;
		max-width: 120px;
	}
</style>